export default "__VITE_ASSET__BSLRqhX8__"